import { API } from '..';

export const fetchAllReqDonateAPI = async () => {
  return new Promise<any>((resolve, reject) => {
    API.get(`/v1/user-service/admin/profile/get-all-request`)
      .then((res) => {
        resolve(res);
      })
      .catch(reject);
  });
};

export const getDonateRequest = async (page = 1, pageSize = 10, filters = {}) => {
  return new Promise<any>((resolve, reject) => {
    API.post(`/v1/user-service/admin/profile/get-donate-requests`, {     
       ...filters,
      pageNumber: page,
      pageSize,})
      .then((res) => {
        resolve(res);
      })
      .catch(reject);
  });
};

/**
 * Duyệt yêu cầu mở nhận donate. `id` là userId (tên tham số cũ giữ nguyên để khớp máy chủ).
 * `note` là lý do duyệt ngoại lệ, bắt buộc khi người dùng chưa đạt điều kiện xét duyệt.
 */
export const approveReqDonateAPI = async (id: string, totpCode?: string, note?: string) => {
  const params: Record<string, string | undefined> = { totpCode };
  if (note && note.trim()) params.note = note.trim();
  return API.put(`/v1/user-service/admin/profile/approve-recive-donate-request/${id}`, null, {
    params,
  });
};

/** Tham số lý do từ chối gửi qua query (máy chủ nhận cả body, nhưng query tránh lỗi body rỗng). */
export const rejectReasonParams = (reasonCode: string, reasonText?: string) => {
  const params: Record<string, string> = { reasonCode };
  const text = reasonText?.trim();
  if (text) params.reasonText = text;
  return params;
};

/**
 * Từ chối yêu cầu mở nhận donate kèm mã lý do và phần ghi thêm. `id` là userId.
 * Máy chủ chỉ cho từ chối yêu cầu đang chờ duyệt.
 */
export const rejectReqDonateAPI = async (id: string, reasonCode: string, reasonText?: string) => {
  return API.put(`/v1/user-service/admin/profile/reject-recive-donate-request/${id}`, null, {
    params: rejectReasonParams(reasonCode, reasonText),
  });
};
